import { Divider } from "antd";
import React from 'react';
import { useSelector } from "../../../../../util/store/store";
import { weightUnit } from "../../../../../util/varibles/constants";
import { formatNumber } from "../../../../../util/varibles/global";
import { IUnit } from "../../../../../util/varibles/interface";
import { getKeyUnit } from "../../../util";
import styles from "./style.module.scss";

export const getAvgWeight = (data: IUnit): number => data.fish_amount ? data.avg_weight : 0

export const showAvgWeight = (data: IUnit) => `${formatNumber(getAvgWeight(data))} gr`;

interface IProps {
    data: IUnit
}

const FishAndWeight: React.FC<IProps> = ({ data }) => {
    const { avg_weight, fish_amount, total_weight } = data;
    const key = getKeyUnit(data);
    const fishChanges = useSelector(state => state.planOperation.fishChanges[key]) || {};
    const changes = Object.keys(fishChanges).reduce((value: number, subKey) => value + fishChanges[subKey], 0);
    const amount = fish_amount + changes;

    return <>
        <div className={styles.wrapper}>
            <span>{formatNumber(amount)} fish</span>
            <Divider orientation='vertical' />
            <span>{showAvgWeight({ ...data, fish_amount: amount })}</span>
        </div>
        <div className='font-s4'>
            {formatNumber(Math.round(changes ? total_weight : amount * avg_weight / 1000) / 1000)} {weightUnit.tons.short}
        </div>
    </>;
};

export default FishAndWeight;
